export default "__VITE_ASSET__BRGM3eSG__"